import SuperadminUsersRoutes from './route-types.js'

// const moduleId = 'A056'

const UserListView = () => import('../../user/UserListView.vue')
const UserView = () => import('../../user/UserView.vue')
const UserDetail = () => import('../../user/UserDetail.vue')
const UserProfile = () => import('../../user/UserProfile.vue')
const UserAccessControl = () => import('../../user/UserAccessControl.vue')
const UserAccessRestriction = () => import('../../user/UserAccessRestriction.vue')
export default [
  {
    path: SuperadminUsersRoutes.UserListView.path,
    name: SuperadminUsersRoutes.UserListView.name,
    component: UserListView,
    meta: {
      //id: moduleId,
      route: 'listing',
      title: 'User',
      name: 'User',
      fkey: 'superuserlisting|filter',
      access: {
        isAdd: true
      }
    }
  },
  {
    path: SuperadminUsersRoutes.UserView.path,
    name: SuperadminUsersRoutes.UserView.name,
    component: UserView,
    props: (route) => ({
      isNew: route.meta.isNew,
      returnUrl: route.query.returnUrl || route.meta.returnUrl
    }),
    meta: {
      //id: moduleId,
      route: 'header',
      title: 'User',
      isNew: false
    },
    children: [
      {
        path: SuperadminUsersRoutes.UserDetail.path,
        name: SuperadminUsersRoutes.UserDetail.name,
        component: UserDetail,
        meta: {
          //id: moduleId,
          title: 'User Detail',
          name: 'UserDetail',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: SuperadminUsersRoutes.UserProfile.path,
        name: SuperadminUsersRoutes.UserProfile.name,
        component: UserProfile,
        meta: {
          //id: moduleId,
          title: 'User Profile',
          name: 'UserProfile',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: SuperadminUsersRoutes.UserAccessControl.path,
        name: SuperadminUsersRoutes.UserAccessControl.name,
        component: UserAccessControl,
        meta: {
          // id: moduleId,
          title: ' Access Control',
          name: 'UserAccessControl',
          access: {
            isEdit: true
          }
        }
      },
      {
        path: SuperadminUsersRoutes.UserAccessRestriction.path,
        name: SuperadminUsersRoutes.UserAccessRestriction.name,
        component: UserAccessRestriction,
        meta: {
          // id: moduleId,
          title: ' Access Restriction',
          name: 'UserAccessRestriction',
          access: {
            isEdit: true
          }
        }
      }
    ]
  }
]
